import { useState } from "react";
import clsx from "clsx";

// MUI
import { Collapse, Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";

// Icons
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { FullCollapseContainerProps } from "../types";

export default function FullCollapseContainer(props: Readonly<FullCollapseContainerProps>) {
	const { addons, sxAddons = undefined } = props;
	const [collapsed, setCollapsed] = useState(true);

	const handleCollapsed = () => {
		setCollapsed(!collapsed);
	};

	return (
		<>
			<Grid
				container
				direction={props.direction || "column"}
				sx={props.sxCollapse || null}
				className={clsx({
					[`${props.className} relative`]: true,
				})}
			>
				<Grid item>
					<Paper
						elevation={0}
						className={clsx({
							"!p-0 !capitalize !place-content-start hover:!bg-[color:--gray-background] !rounded-b-none": true,
							"!rounded-t-[10px]": props.roundedTop,
							"!rounded-t-none": !props.roundedTop,
							// This is required for other components to target it and apply custom styles
							"full-collapse-area-button": true,
						})}
						onClick={handleCollapsed}
					>
						{props.loading ? (
							<Typography>
								<Skeleton variant="text" width={350} height={36} />
							</Typography>
						) : (
							<Typography
								className={clsx({
									// big-title
									"!font-montserrat text-[color:--text-color] !text-[24px] !font-medium": true,
									// big-area
									"py-[20px] pl-[32px]": true,
								})}
							>
								{props.title || ""}
								{props.arrow && (
									<ArrowForwardIosRoundedIcon
										className={clsx({
											"ml-[10px]": true,
											"rotate-90": collapsed,
											"-rotate-90": !collapsed,
										})}
									/>
								)}
							</Typography>
						)}
					</Paper>

					{addons && (
						<Stack
							direction={"row"}
							justifyContent={"flex-end"}
							alignItems={"center"}
							className={clsx({
								"absolute right-[30px] top-[22px]": !sxAddons,
							})}
							sx={sxAddons}
						>
							{addons}
						</Stack>
					)}
				</Grid>
			</Grid>

			{props.bottomDivider && (
				<Divider
					className={clsx({
						"!border-b !border-[#CCC]": !props.sxBottomDivider,
					})}
					sx={props.sxBottomDivider}
				></Divider>
			)}

			<Collapse in={!collapsed} collapsedSize={0} timeout={100}>
				{props.children}
			</Collapse>

			<Collapse in={props.sectionDivider && !collapsed} collapsedSize={0} timeout={100}>
				<Divider
					className={clsx({
						"!ml-[20px] !mr-[20px] !border-b !border-[#CCC]": !props.sxSectionDivider,
					})}
					sx={props.sxSectionDivider}
				></Divider>
			</Collapse>
		</>
	);
}
